/**
 * Agent version freshness. The build date is encoded as the version
 * string `YYYY-MM-DD-HHMM` (see build_agent_tarball.sh). Source-run
 * agents report "dev". Centralised so OperatorCard and any future
 * fleet view share one staleness rule.
 */

// Agents older than this are flagged in the UI so a dispatcher can push
// an update — old builds miss recent remote commands (e.g. notify_operator).
const STALE_AGE_DAYS = 7

export interface AgentVersionStatus {
  /** true when the build is older than STALE_AGE_DAYS */
  stale: boolean
  /** whole days since the build, or null when unknown/dev */
  ageDays: number | null
  /** raw version for display, or "dev"/"—" */
  label: string
}

export function getAgentVersionStatus(
  version: string | null | undefined
): AgentVersionStatus {
  if (!version || version === 'dev') {
    return { stale: false, ageDays: null, label: version || '—' }
  }
  const match = version.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!match) {
    return { stale: false, ageDays: null, label: version }
  }
  const [, y, m, d] = match
  const built = new Date(Number(y), Number(m) - 1, Number(d))
  const ageDays = Math.floor((Date.now() - built.getTime()) / 86_400_000)
  return { stale: ageDays > STALE_AGE_DAYS, ageDays, label: version }
}
